// extracted by mini-css-extract-plugin
export default {"popup__title":"inactivityLogoutPopup_popup__title__ApBOu","popup__text":"inactivityLogoutPopup_popup__text__lPCoi","popup__nextBtn":"inactivityLogoutPopup_popup__nextBtn__ZC66i"};